import { useCallback } from 'react';
import { usePendo, useSdnUser } from '@spins-gcp/shared-components-react';

export function usePendoPortal(apiKey: string | undefined) {
  const { user } = useSdnUser();

  const { track: pendoTrack } = usePendo({
    apiKey: apiKey || '',
    enabled: !!apiKey && !!user && !window['Cypress' as keyof Window],
    visitor: user
      ? {
          id: user.id,
          email: user.email,
          fname: user.firstName,
          lname: user.lastName,
        }
      : {},
    account: user
      ? {
          id: user.company.id,
          name: user.company.name,
          type: user.company.type,
        }
      : {},
  });

  const track = useCallback(
    (event: string, metadata?: Record<string, unknown>) => {
      if (!apiKey || (globalThis as GlobalThis).pendo?.apiKey !== apiKey)
        return;

      try {
        pendoTrack(event, metadata);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Pendo tracking failed', error);
      }
    },
    [pendoTrack, apiKey]
  );

  return { track };
}
